import commodityUrl from '../../page/url';

export default {

  login: '/merchant/app/login/signIn', //登录
  tokenSignIn: 'merchant/app/authorize/signIn', // token 登录
  getQrCode: 'merchant/app/login/getQrCode', // 获取扫码登陆uuid
  signInByQrCode: 'merchant/app/login/signInByQrCode', // 扫码登陆
  sso: '/sso/sso',
  logout: "/merchant/app/login/signOut", //登出
  register: "/merchant/member/register", //注册
  findPwd: "/merchant/app/login/findPwd", // 忘记密码
  // sendNoLogin: "/merchant/app/verifyCode/sendNoLogin", //验证码-发送验证码（登录、注册）
  sendNoLogin: "/merchant/app/verifyCode/sendLogin", //验证码-发送验证码（登录、注册）
  sendFindPwd: "/merchant/app/verifyCode/sendFindPwd", //验证码-发送验证码（忘记密码）
  sendV2FindPwd: "/merchant/app/v2/verifyCode/sendFindPwd", //验证码-发送验证码（忘记密码）
  sendV3FindPwd: "/merchant/app/v3/verifyCode/sendFindPwd", //验证码-发送验证码（忘记密码）
  verificationCode: "/merchant/app/login/verificationCode", // 忘记密码 - 验证验证码是否正确
  send: "/merchant/app/verifyCode/send", //验证码-发送验证码（需要登录）
  wxSend: "/merchant/app/weixinCode/send", //  微信验证发送短信
  appInit: '/merchant/app/v2/common/appInit', // 初始化接口 配置接口
  //menuRole: '/oxMenu/listByRoot', //  获取侧边导航栏,
  menuRole: '/merchant/menu/list',
  loginApp: '/login/app', //获取APP
  loginAppList: '/sso/getSsoApp', // 登陆时选择机构和应用
  loginOrgList: '/sso/getSsoOrg',
  uploadUrl: '/api/merchant/upload/uploadSingle',
  changeloginpwd: 'merchant/app/member/changePwd', //修改登录密码
  getImg: '/merchant/app/kaptcha/getImg', //获取图片验证码
  getgraphicVerificationCode: "merchant/app/captcha/get", // 获取图形验证码
  checkGraph: "merchant/app/captcha/check", // 校验图形验证码
  //uploadUrl: '/api/attachment/upload', // 附件
  shopRechargeApplyWaitTotal: "merchant/shopRechargeApply/waitTotal", //门店充值申请-待处理总数
  getgraphicVerificationCode: "merchant/app/captcha/get", // 获取图形验证码
  checkGraph: "merchant/app/captcha/check", // 校验图形验证码
  smsGraphics: "api/merchant/app/v3/verifyCode/sendFindPwd", // 
  merchatOss: {
    getSts: "/merchant/app/v2/upload/getSts", // 获取oss凭证
    listUploadId: "/merchant/app/v2/upload/listUploadId", // 获取oss参数
    deleteImg: "/merchant/app/v2/upload/deleteImg", // 删除oss上的图片
    getPrivateImgUrl: '/merchant/app/v2/upload/getPrivateImgUrl', // oss 身份证上传 先掉后台接口解密，用于显示图片
  },
    api: {
        list: '/apidoc/list',
        get: '/apidoc/get'
    },
    table: { // 系统配置
        list: "/table/list",
        get: '/table/get',
        del: '/table/delete',
        save: '/table/save'
    },
    synchLog: {
        list: '/synchLog/list',
        save: '/synchLog/save',
        get: '/synchLog/get',
        del: '/synchLog/delete'
    },
    workflow: {
        list: '/workflow/list',
        save: '/workflow/save',
        get: '/workflow/get',
        del: '/workflow/delete'
    },

    ...commodityUrl,
    cookieUrl: process.env.COOKIE_DOMAIN
}


// import udbUrl from '../../page/udb/url'
// import systemUrl from '../../page/system/url'

// export default {
// 	//login: '/sso/login', //登录
// 	login: '/merchant/login/signIn', //登录
// 	sso: '/sso/sso',
// 	logout: "/sso/logout", //登出
// 	//menuRole: '/oxMenu/listByRoot', //  获取侧边导航栏,
// 	menuRole: '/merchant/menu/list',
// 	loginApp: '/login/app', //获取APP
// 	loginAppList: '/sso/getSsoApp', // 登陆时选择机构和应用
// 	loginOrgList:'/sso/getSsoOrg',
// 	uploadUrl: '/api/attachment/upload', // 附件

// 	api: {
// 		list: '/apidoc/list',
// 		get: '/apidoc/get'
// 	},
// 	table: { // 系统配置
// 		list: "/table/list",
// 		get: '/table/get',
// 		del: '/table/delete',
// 		save: '/table/save'
// 	},
// 	synchLog: {
// 		list: '/synchLog/list',
// 		save: '/synchLog/save',
// 		get: '/synchLog/get',
// 		del: '/synchLog/delete'
// 	},
// 	workflow: {
// 		list: '/workflow/list',
// 		save: '/workflow/save',
// 		get: '/workflow/get',
// 		del: '/workflow/delete'
// 	},
// 	...udbUrl,
// 	...systemUrl,
// 	cookieUrl:process.env.COOKIE_DOMAIN
// }